<template>
  <b-container fluid id="tables">
    <b-row class="text-center d-flex justify-content-center mb-3">
      <b-col lg="3" xs="3" md="3" xl="3" class="my-3">
        <input class="form-control" type="date" v-model="datas.date1" />
      </b-col>
      <b-col lg="3" xs="3" md="3" xl="3" class="my-3">
        <input class="form-control" type="date" v-model="datas.date2" />
      </b-col>
      <b-col lg="4" xs="4" md="4" xl="4" class="my-3">
        <v-select
          :options="names"
          class="hisobotselect"
          v-model="datas.direct_id"
          :reduce="options => options.id"
          label="name"
          :placeholder="$t('ходимни танланг...')"
        />
      </b-col>
      <b-col lg="2" xs="2" md="2" xl="2" class="my-3">
        <button
          type="button"
          class="btn text-white"
          style="background: #195FB0; width: 130px; font-size: 14px"
          @click="Send()"
        >
          <img
            src="../../../public/Vector.png"
            alt=""
            style="margin-right: 5px"
          />
          {{ $t("Кўриш") }}
        </button>
      </b-col>
    </b-row>
    <table class="table table-striped table-bordered">
      <thead>
        <tr class="text-center">
          <th scope="col">#</th>
          <th>{{ $t("Номи") }}</th>
          <th>{{ $t("Сони") }}</th>
          <th>{{ $t("Тушум") }}</th>
          <th>{{ $t("Умумий сумма") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="text-center"
          v-for="(item, index) in doctor"
          :key="index"
          v-on:dblclick="Clicked(item.direct_id)"
        >
          <td>{{ index + 1 }}</td>
          <td>
            <span>{{ item.direct_name }}</span>
          </td>
          <td>{{ item.count }}</td>
          <td>
            {{ item.doctor.name }}
          </td>
          <td>{{ item.umumiy_sum | numFormat }}</td>
        </tr>
        <tr
          class="text-center"
          v-for="(item, index) in inspection"
          :key="index"
          v-on:dblclick="Clicked(item.direct_id)"
        >
          <td>{{ index + 1 }}</td>
          <td>
            <span>{{ item.direct_name }}</span>
          </td>
          <td>{{ item.count }}</td>
          <td>
            {{ item.inspection.name }}
          </td>
          <td>{{ item.umumiy_sum | numFormat }}</td>
        </tr>
        <tr class="text-center">
          <td id="jami" colspan="4">
            {{ $t("Жами") }}
          </td>
          <td>{{ jami_sum | numFormat }}</td>
        </tr>
      </tbody>
    </table>
  </b-container>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      datas: {
        date1: new Date().toISOString().slice(0, 8) + "01",
        date2: new Date().toISOString().slice(0, 10),
        direct_id: null
      },
      doctors: null,
      names: [],
      jami_sum: 0,
      tushum: null,
      doctor: "",
      doctorList: [],
      doctor_sverka: "",
      errors: "",
      doctor: {},
      inspection: {},
      index: 0
    };
  },
  created() {
    let self = this;
    if (localStorage.getItem("direct") != null) {
    }
    //  self.Send()
  },
  methods: {
    Clicked(id) {
      this.datas.direct_id = id;
      localStorage.setItem("direct", JSON.stringify(this.datas));
      let route = this.$router.resolve({
        path: "/direct_sverka"
      });
      window.open(route.href, "_blank");
      // this.$router.push({ path: "direct_sverka" });
    },
    Send() {
      let self = this;
      var datas = {
        datetime1: parseInt(
          new Date(self.datas.date1)
            .valueOf()
            .toString()
            .slice(0, 10)
        ),
        datetime2:
          parseInt(
            new Date(self.datas.date2)
              .valueOf()
              .toString()
              .slice(0, 10)
          ) + 86399,
        direct_id: self.datas.direct_id
      };
      axios({
        method: "post",
        url: "/hisobot/direct_hisobot",
        data: datas
      }).then(function(response) {
        self.doctor = response.data.doctor;
        self.inspection = response.data.inspections;
        self.jami_sum = response.data.jami_suma.umumiy_sum;
      });
    },
    getDoctor() {
      let self = this;
      axios({
        method: "get",
        url: "/direct/all"
      }).then(res => {
        if (res) {
          self.names = res.data.data;
        }
      });
    }
  },
  mounted() {
    this.getDoctor();
  }
};
</script>
<style scoped>
.hisobotselect .vs__selected-options span:first-child {
  width: 90% !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
table {
  margin: 0px 0px;
  width: 1050px;
}

label,
td,
th,
tr {
  font-family: "Times New Roman", Times, serif;
  font-weight: bolder;
  text-transform: capitalize;
  font-size: 15px;
  height: 30px !important;
}
#tables {
  min-height: 100vh;
  width: 99% !important;
}
.reds {
  color: red;
}
#bosh {
  width: 50px !important;
}
th {
  color: #195fb0;
  background-color: #f4f7fb;
}
</style>
